// Represents an action generated by a logic applied to a cart item reference.
// Actions can be gifts, discounts, freeship, reward points, vouchers, etc.
import { type ProductInterface } from '../../types/front.graphql';

export enum ActionType {
    GIFT = 'free_gift',
    DISCOUNT = 'discount',
    FREE_SHIP = 'free_ship',
    POINT = 'point',
    VOUCHER = 'voucher',
    OTHER = 'other', // Fallback for string values
}

export interface CartItemReferenceAction {
    id?: string; // Unique identifier for the action
    cartItemReferenceLogicId?: string; // Foreign key to CartItemReferenceLogic
    actionType: ActionType; // Type of action
    actionProduct?: ProductInterface; // Product ID if the action is a gift product
    actionValue?: number | null; // Value if the action is a discount/point/money
    actionNote?: string | null; // Optional note for the action
    actionQty?: number | null; // Quantity of the action (e.g., number of gifts)
    createdAt?: string; // ISO timestamp of action creation
}
